import request from '../requestPB'
import { SERVER_DOMAIN, PROTO_MODULE, STOCK_SERVER_DOMAIN, USER_FROM } from '../constant'

// 查询供应商列表  POST  /purchase/merchant/list
export const fetchMerchantList = (data) => {
  return request({
    url: `${STOCK_SERVER_DOMAIN}/purchase/merchant/list`,
    data,
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.PurchaseMerchantListRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.PurchaseMerchantListResponse',
    ERROR_ACTION: 'toast',
    httpAddress: 'stock',
    // PROTO_MODULE: PROTO_MODULE.LOTTERY,
    TOKEN_REQUIRED: true,
    businessId: USER_FROM.CAIGOU
  })
}

// 查询供应商商品列表 POST 
export const fetchProductList = (data) => {
  return request({
    url: `${STOCK_SERVER_DOMAIN}/purchase/merchant/productList`,
    data,
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.PurchaseMerchantProductListRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.PurchaseMerchantProductListResponse',
    ERROR_ACTION: 'toast',
    httpAddress: 'stock',
    // PROTO_MODULE: PROTO_MODULE.LOTTERY,
    TOKEN_REQUIRED: true,
    businessId: USER_FROM.CAIGOU
  })

  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({
        errorCode: 0,
        errorMsg: 'Success',
        isEnd: true,
        productList: [
          { appearancePic: '', productName: '东北花色的被盗，炒藕家是不是啥办法煞风景京东方吧', price: 17900, status: 1, pid: 4567 },
          { appearancePic: '', productName: '东北花色的被盗，炒藕家是不是啥办法煞风景京东方吧', price: 17900, status: 2, pid: 4567 }
        ]
      }, 500)
    })
  })
}

// 查询供应商商品详情 POST 
export const fetchProductDetail = (data) => {
  return request({
    url: `${STOCK_SERVER_DOMAIN}/purchase/merchant/productDetail`,
    data,
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.PurchaseMerchantProductDetailRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.PurchaseMerchantProductDetailResponse',
    ERROR_ACTION: 'toast',
    httpAddress: 'stock',
    // PROTO_MODULE: PROTO_MODULE.LOTTERY,
    TOKEN_REQUIRED: true,
    businessId: USER_FROM.CAIGOU
  })

}

// 添加到购物车 POST /purchase/cartAdd
export const addToCart = (data) => {
  return request({
    url: `${STOCK_SERVER_DOMAIN}/purchase/cartAdd`,
    data,
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.PurchaseCartAddRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.PurchaseCartAddResponse',
    ERROR_ACTION: 'toast',
    httpAddress: 'stock',
    // PROTO_MODULE: PROTO_MODULE.LOTTERY,
    TOKEN_REQUIRED: true,
    businessId: USER_FROM.CAIGOU
  })

  return new Promise((resolve, reject) => {
    setTimeout(resolve({
      errorCode: 0,
      errorMsg: 'Success',
    }), 500)
  })
}

// 查询购物车商品列表 POST /purchase/cartList
export const fetchCartList = (data) => {
  return request({
    url: `${STOCK_SERVER_DOMAIN}/purchase/cartList`,
    data,
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.PurchaseCartListRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.PurchaseCartListResponse',
    ERROR_ACTION: 'toast',
    httpAddress: 'stock',
    // PROTO_MODULE: PROTO_MODULE.LOTTERY,
    TOKEN_REQUIRED: true,
    businessId: USER_FROM.CAIGOU
  })

  return new Promise((resolve, reject) => {
    setTimeout(resolve({
      errorCode: 0,
      errorMsg: 'Success',
      cartList: [
        { appearancePic: '', productName: '东北花色的被盗，炒藕家是不是啥办法煞风景京东方吧', price: 17900, status: 1, pid: 4567 },
        { appearancePic: '', productName: '东北花色的被盗，炒藕家是不是啥办法煞风景京东方吧', price: 17900, status: 2, pid: 4567 },
      ]
      // isEnd: false,
    }))
  })
}

// 从购物车列表中移除 POST /purchase/cartDel
export const delCart = (data) => {
  return request({
    url: `${STOCK_SERVER_DOMAIN}/purchase/cartDel`,
    data,
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.PurchaseCartDelRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.PurchaseCartDelResponse',
    ERROR_ACTION: 'toast',
    httpAddress: 'stock',
    // PROTO_MODULE: PROTO_MODULE.LOTTERY,
    TOKEN_REQUIRED: true,
    businessId: USER_FROM.CAIGOU
  })

  return new Promise((resolve, reject) => {
    setTimeout(resolve({
      errorCode: 0,
      errorMsg: 'Success',
    }))
  })
}

// 生成订单 POST /purchase/order/gen
export const genOrder = (data)  => {
  return request({
    url: `${STOCK_SERVER_DOMAIN}/purchase/order/gen`,
    data,
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.PurchaseOrderGenRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.PurchaseOrderGenResponse',
    ERROR_ACTION: 'toast',
    httpAddress: 'stock',
    // PROTO_MODULE: PROTO_MODULE.LOTTERY,
    TOKEN_REQUIRED: true,
    businessId: USER_FROM.CAIGOU
  })

  return new Promise((resolve, reject) => {
    setTimeout(resolve({
      errorCode: 0,
      errorMsg: 'Success',
      orderNo: '12345'
    }))
  })
}

// 银行汇款接口
export const bankPayOrder = (data) => {
  return request({
    url: `${STOCK_SERVER_DOMAIN}/purchase/bankPay`,
    data,
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.PurchaseBankPayRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.PurchaseBankPayResponse',
    ERROR_ACTION: 'toast',
    httpAddress: 'stock',
    // PROTO_MODULE: PROTO_MODULE.LOTTERY,
    TOKEN_REQUIRED: true
  })

  return new Promise((resolve, reject) => {
    setTimeout(resolve({
      errorCode: 0,
      errorMsg: 'Success',
    }))
  })
}

// 微信浏览器订单支付 POST @token_required
export const payOnWxBrowser = (data) => {
  return request({
    url: `${STOCK_SERVER_DOMAIN}/purchase/order/payOnWxBrowser`,
    data,
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.PurchaseOrderPayOnWxBrowserRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.PurchaseOrderPayOnWxBrowserResponse',
    ERROR_ACTION: 'toast',
    httpAddress: 'stock',
    // PROTO_MODULE: PROTO_MODULE.LOTTERY,
    TOKEN_REQUIRED: true,
    businessId: USER_FROM.CAIGOU
  })

  return new Promise((resolve, reject) => {
    setTimeout(resolve({
      errorCode: 0,
      errorMsg: 'Success'
    }))
  })
}

// 订单支付 POST @token_required
export const fetchPay = (data) => {
  return request({
    url: `${STOCK_SERVER_DOMAIN}/purchase/order/pay`,
    data,
    method: 'POST',
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.PurchaseOrderPayRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.PurchaseOrderPayResponse',
    ERROR_ACTION: 'toast',
    httpAddress: 'stock',
    // PROTO_MODULE: PROTO_MODULE.LOTTERY,
    TOKEN_REQUIRED: true,
    businessId: USER_FROM.CAIGOU
  })

  return new Promise((resolve, reject) => {
    setTimeout(resolve({
      errorCode: 0,
      errorMsg: 'Success'
    }))
  })
}

// 在获取网页授权access_token时获取openid POST /account/webPageOpenid
export const webPageOpenid = ({ code }) => {
  return request({
    url: `${SERVER_DOMAIN}/account/webPageOpenid`,
    method: 'POST',
    data: { code }
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSWebPageOpenidRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSWebPageOpenidResponse',
    // ERROR_ACTION: 'toast',
    TOKEN_REQUIRED: true,
    businessId: USER_FROM.CAIGOU
  })
}